import { createContext } from 'react';

const DataConsumptionContext = createContext();

export default DataConsumptionContext;
